<form
  [formGroup]="form"
  (ngSubmit)="onSubmitFormValues($event)"
  [patchForm]="bookingRooms"
  id="rooms-form"
>
  <div class="row">
    <div class="col-12 col-lg-3 border-lg-right border-primary pe-0">
      <p *ngIf="isLoading$ | async">Booking loading...</p>
      <div
        class="me-lg-n1 bg-white"
        *ngIf="booking.details.participants.numberSleepOver"
      >
        <p>
          {{ 'general.numberOf' | translate }}
          {{ 'bookingModule.sleepingOver' | translate }}:<span
            class="badge bg-soft-primary rounded-pill ms-2"
            >{{ booking.details.participants.numberSleepOver }}</span
          >
        </p>
      </div>
      <ul
        class="nav nav-tabs date-list align-items-center gap-2 justify-content-between mb-3"
        role="tablist"
      >
        <li class="nav-item">
          <add-date-btn
            [text]="'bookingModule.addDateBefore' | translate"
            (onClick)="addDateBefore()"
          ></add-date-btn>
        </li>

        <list-date-li-btn
          class="nav-item"
          *ngFor="let date of datesList; index as dateIndex"
          [date]="date"
          [index]="dateIndex"
          [selectedDate]="selectedDate"
          [isFormValid]="
            !getDatesForm(datesList[dateIndex])?.errors?.missTotal &&
            !getDatesForm(datesList[dateIndex])?.invalid &&
            !(
              dateIndex !== 0 &&
              getTotalPersons(getDatesForm(datesList[dateIndex]), dateIndex) ===
                0
            )
          "
          [selectedLanguage]="configurationService.selectedLang$ | async"
          (onDateClicked)="onDateClick($event, dateIndex)"
          (onDateRemoved)="removeDate($event)"
          role="tab"
        ></list-date-li-btn>
        <li class="nav-item">
          <add-date-btn
            (onClick)="addDateAfter()"
            [text]="'bookingModule.addDateAfter' | translate"
          ></add-date-btn>
        </li>
      </ul>
    </div>

    <div class="col-md">
      <ng-container *ngFor="let _ of datesForm?.controls; index as dateIndex">
        <form
          class="w-100"
          [formGroup]="getDatesForm(datesList[dateIndex])"
          [hidden]="!selectedDate.isSame(datesList[dateIndex], 'day')"
        >
          <h2 class="mb-3">
            {{
              datesList[dateIndex]
                | dateFromMoment
                | date
                  : 'EEE, d MMMM yyyy'
                  : undefined
                  : (configurationService.selectedLang$ | async)
            }}
          </h2>

          <button
            *ngIf="dateIndex !== 0"
            class="btn btn-soft-primary btn-sm"
            type="button"
            data-test-id="copy-from-previous-day-button"
            [disabled]="dateIndex === 0"
            (click)="copyFromLastDay(dateIndex)"
          >
            <i role="img" class="fa fa-clone me-2" aria-hidden="true"></i>
            {{ 'bookingModule.copyFromPreviousDay' | translate }}
          </button>

          <div [hidden]="(productEntities$ | async)?.length < 1">
            <!-- header -->
            <div class="row gx-2 mb-2 align-items-center">
              <small class="col-6 col-lg-4 offset-6">{{
                'bookingModule.pricePerPersonPerNight' | translate
              }}</small>

              <small class="d-none d-md-block col-6 col-md-2">{{
                'bookingModule.persons' | translate
              }}</small>
            </div>
            <!-- end header -->
            <div class="list-group mb-3">
              <div
                *ngFor="
                  let activityResourcePair of datesProductsMap.get(
                    datesList[dateIndex]?.format()
                  )
                "
                [formGroup]="
                  datesForm
                    | getSelectedDateProductFormGroup
                      : activityResourcePair.resourceProductId
                      : datesList[dateIndex]
                      : activityResourcePair.activityProductId
                "
                class="list-group-item"
                [ngClass]="{
                  'bg-primary text-white':
                    (
                      datesForm
                      | getSelectedDateProductFormGroup
                        : activityResourcePair.resourceProductId
                        : datesList[dateIndex]
                        : activityResourcePair.activityProductId
                    ).controls.selected?.value === true
                }"
              >
                <div class="row gx-2 align-items-center">
                  <div class="col-6 col-lg-6 mb-3 mb-md-0">
                    <div class="d-flex justify-content-start">
                      <strong
                        >{{
                          activityResourcePair.activityProductId
                            | getTranslation: 'product' : 'description'
                            | async
                        }}
                      </strong>
                      <span data-test-id="overnight-resource-description">
                        &nbsp; -
                        {{
                          activityResourcePair.resourceProductId
                            | getTranslation: 'product' : 'description'
                            | async
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="col-6 col-lg-4 mb-3 mb-md-0">
                    {{
                      bookingMultiDayService.getProductPrice(
                        (productEntities$ | async)[
                          activityResourcePair.activityProductId
                        ],
                        booking?.details?.targetGroup
                      ) | currency
                    }}
                  </div>

                  <div class="col-6 col-md-2">
                    <small class="d-md-none text-center">{{
                      'bookingModule.persons' | translate
                    }}</small>

                    <input
                      class="form-control"
                      type="number"
                      [min]="0"
                      (input)="setChangeValue()"
                      formControlName="persons"
                      data-test-id="input-persons-overnight"
                      [attr.aria-invalid]="
                        (
                          datesForm
                          | getSelectedDateProductFormGroup
                            : activityResourcePair.resourceProductId
                            : datesList[dateIndex]
                            : activityResourcePair.activityProductId
                        ).controls.persons.invalid
                          ? 'true'
                          : null
                      "
                    />

                    <small
                      class="text-muted d-block mt-1"
                      *ngIf="
                        isSharedResourceDisabled(
                          datesList[dateIndex],
                          activityResourcePair.activityProductId,
                          activityResourcePair.resourceProductId
                        )
                      "
                    >
                      {{
                        'bookingModule.resourceAlreadySelected' | translate
                      }}
                    </small>

                    <p
                      class="invalid-feedback"
                      role="alert"
                      aria-atomic="true"
                      *ngIf="
                        (
                          datesForm
                          | getSelectedDateProductFormGroup
                            : activityResourcePair.resourceProductId
                            : datesList[dateIndex]
                            : activityResourcePair.activityProductId
                        ).invalid
                      "
                    >
                      {{
                        'bookingModule.resourceNotAvailable'
                          | translate
                          | replaceVarInString
                            : '$max$'
                            : (
                                datesForm
                                | getSelectedDateProductFormGroup
                                  : activityResourcePair.resourceProductId
                                  : datesList[dateIndex]
                                  : activityResourcePair.activityProductId
                              )?.value?.maxResourceParticipants
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3" [hidden]="selectedDate !== datesList[dateIndex]">
            <div class="row pb-3 align-items-center">
              <h3 class="col-auto mb-0 h4">
                {{ 'bookingModule.totalPersons' | translate }}
              </h3>
              <div class="col text-end">
                <span
                  class="fw-bold px-4 py-2 rounded-pill bg-soft-danger"
                  [ngClass]="{
                    ' bg-soft-danger':
                      getTotalPersons(getDatesForm(datesList[dateIndex])) >
                        booking.details.participants.numberSleepOver ||
                      (dateIndex !== 0 &&
                        getTotalPersons(getDatesForm(datesList[dateIndex])) ===
                          0),
                    ' bg-soft-success':
                      getTotalPersons(getDatesForm(datesList[dateIndex])) <=
                      booking.details.participants.numberSleepOver
                  }"
                >
                  {{ getTotalPersons(getDatesForm(datesList[dateIndex])) }}/{{
                    booking.details.participants.numberSleepOver
                  }}
                </span>
              </div>
            </div>
            <div class="mb-3">
              <label class="h4">{{ 'bookingModule.note' | translate }}</label>
              <textarea formControlName="note" class="form-control"></textarea>
            </div>
          </div>
        </form>
      </ng-container>

      <div class="row gx-2 mt-5">
        <div class="col-md-auto mb-3 mb-md-0">
          <button
            class="btn"
            type="button"
            (click)="setForWholeStay(selectedDateIndex)"
            [ngClass]="wholeStayStatus ? 'btn-success' : 'btn-soft-primary'"
            data-test-id="use-same-arrangement"
          >
            {{ 'bookingModule.useSameArrangement' | translate }}
            <i
              class="fa me-2"
              role="img"
              [ngClass]="wholeStayStatus ? 'fa-check-circle' : 'fa-question'"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        <div class="col">
          <button
            type="submit"
            data-test-id="continue-step-rooms"
            class="btn btn-primary w-100 d-block"
            [disabled]="errorBookeableProduct"
            form="rooms-form"
          >
            {{ 'bookingModule.continue' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
